import { Component } from '@angular/core';
import { BreakpointService } from '@libs/index';

@Component({
  selector: 'app-static-content-online-booking-benefit',
  templateUrl: './static-content-online-booking-benefit.component.html',
  styleUrls: ['./static-content-online-booking-benefit.component.scss'],
})
export class StaticContentOnlineBookingBenefitComponent {
  constructor(public breakpointService: BreakpointService) {}
}
